export enum SmevMonitoringChartTypesEnum {
  FAILED_MESSAGES = 'failedMessages',
  FAILED_BY_SMEV_MESSAGES = 'failedBySmevMessages',
  SUCCESSFUL_MESSAGES = 'successfulMessages',
}
